import React, { useState, useEffect, useCallback } from 'react';
import AddressesContainer from '../../global/AddressesContainer';
import { getMembershipAddresses, createUserAddress, updateUserAddress } from '../../utils/service';
import { ROUTE_MY_ACCOUNT } from '../../config/routes';
import PageContent from '../../global/PageContent';
import getPriorityAddress from '../../utils/addresses';

import './MembershipAddresses.scss';

const MembershipAddresses = () => {
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAddresses = useCallback(async () => {
    setLoading(true);
    setError(null);

    const { data, error: fetchError } = await getMembershipAddresses({ pageSize: 2 });

    if (fetchError) {
      setError('Failed to load addresses');
      return;
    }

    const userAddresses = data?.userAddresses || [];
    setAddresses(userAddresses);

    if (userAddresses.length > 0) {
      const defaultAddress = getPriorityAddress(userAddresses) || userAddresses[0];
      setSelectedAddress(defaultAddress);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    fetchAddresses();
  }, [fetchAddresses]);

  const handleAddressSelect = useCallback((address) => {
    setSelectedAddress(address);
  }, []);

  const handleAddressSave = useCallback(async (addressData) => {
    setError(null);

    // If the address has a UID, it's an update; otherwise, it's a new address
    if (addressData.uid) {
      const { error: updateError } = await updateUserAddress({
        addressUid: addressData.uid,
        fromAddress: addressData,
      });

      if (updateError) {
        setError('Failed to update address');
        console.error(updateError);
        return;
      }
    } else {
      const { error: createError } = await createUserAddress({
        fromAddress: addressData,
      });

      if (createError) {
        setError('Failed to create address');
        console.error(createError);
        return;
      }
    }

    await fetchAddresses();
  }, [fetchAddresses]);

  const handleBack = useCallback(() => {
    fetchAddresses();
  }, []);

  return (
    <PageContent
      isLoading={loading}
      error={error}
      className="MembershipAddresses"
      backButtonText="GO TO MY ACCOUNT"
      parentUrl={ROUTE_MY_ACCOUNT}
    >
      <div className="MembershipAddresses__content">
        <AddressesContainer
          addresses={addresses}
          setAddresses={setAddresses}
          selectedAddress={selectedAddress}
          onAddressSelect={handleAddressSelect}
          onAddressSave={handleAddressSave}
          onContinue={handleBack}
        />
      </div>

    </PageContent>
  );
};

export default MembershipAddresses;
